import { useAllSearchParams, useRouter } from '@capsicum/common-web';
import { useWCPledgeBasketState } from '@capsicum/features/world-championship-pledge/shared';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const useEmptyBasketDigest = () => {
	const searchParams = useAllSearchParams();
	const emptyBasketParam = searchParams.get('empty_basket');
	const { emptyBasket } = useWCPledgeBasketState();
	const router = useRouter();
	const pathname = usePathname();

	useEffect(() => {
		if (emptyBasketParam) {
			emptyBasket();
			const newParams = new URLSearchParams(searchParams);

			newParams.delete('empty_basket');

			const newUrl = newParams.toString() ? `${pathname}?${newParams.toString()}` : pathname;

			router.replace(newUrl);
		}
	}, [emptyBasketParam]);

	return null;
};
